"use client";

import { memo } from "react";

import { useRovingFocus } from "../../hooks";
import {
  navbarMenuItemStyles,
  navbarMenuItemIconStyles,
  navbarMenuItemContentStyles,
  navbarMenuItemLabelStyles,
  navbarMenuItemDescriptionStyles,
} from "./styles/navbar-menu-item.styles";

import type { NavbarMenuItemProps } from "./types/navbar-menu-item.types";

export const NavbarMenuItem: React.FC<NavbarMenuItemProps> = memo((props) => {
  const { label, href, description, icon, className, ...rest } = props;

  const handleKeypress = useRovingFocus({ orientation: "vertical" });

  return (
    <li>
      <a href={href} className={navbarMenuItemStyles({ className })} onKeyDown={handleKeypress} {...rest}>
        {icon ? <span className={navbarMenuItemIconStyles()}>{icon}</span> : null}

        <div className={navbarMenuItemContentStyles()}>
          <span className={navbarMenuItemLabelStyles()}>{label}</span>
          {description && <span className={navbarMenuItemDescriptionStyles()}>{description}</span>}
        </div>
      </a>
    </li>
  );
});
